(function ($) {
  whatPeopleAreSayingModuleV1 = {
    formatter: $('.what-people-are-saying-module-v1'),
    'bottom-value-start': '-50px',
    'bottom-value-hover': '-25px',
    'bottom-value-active': '-1px'
  };

  Drupal.behaviors.whatPeopleAreSayingModuleV1 = {
    get: function (key) {
      return whatPeopleAreSayingModuleV1[key];
    },

    set: function (key, val) {
      whatPeopleAreSayingModuleV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.once('what-people-are-saying-module-v1-init-processed').each(function () {
        var thisFormatter = $(this);
        // Set defaultDataItem value
        var defaultDataItem = thisFormatter.find('.slides .shade-box:first').data('item'); // grab this from the first shade in the list of slides, not necessarily the first review in the reviews container

        // Add data-item attribute to reviews
        thisFormatter.find('.product .shades .manual-reviews').find('.manual-review').each(function (i) {
          var review = $(this);

          review.attr('data-item', i + 1);

          // also, trim the markup of each bit of each review, stripping text nodes/p tags that are, after trimming,
          // empty, and trimming all other nodes
          review.find('.manual-review-content, p').each(function () {
            var $this = $(this);

            $this.html($this.html().trim());
          });
        });

        // Add data-item attribute to wrappers
        thisFormatter.find('.product .shades .manual-reviews').find('.wrapper').each(function (i) {
          var wrapper = $(this);

          wrapper.attr('data-item', i + 1);
        });

        // Add data-item attribute to shades, resizing shade-box and its image to the image's size, but only when the images have loaded
        var imagesLoaded = {},
          checkImages = function (callback) {
            var imagesHaveBeenLoaded = true;

            $.each(imagesLoaded, function (i, value) {
              if (value === false) {
                imagesHaveBeenLoaded = false;

                return false;
              }
            });
            if (imagesHaveBeenLoaded) {
              callback();
            }
          };

        thisFormatter.find('.product .shades .col2 ul li').each(function (i) {
          var list = $(this);
          var shade = list.find('.shade-box');
          var img = shade.find('img');

          shade.attr('data-item', i + 1);

          // make a copy of the image, to circumvent how CSS in parent elements might affect width calculations
          $('<img/>', {
            'src': img.attr('src')
          }).on('load', function() {
            if (typeof imagesLoaded[shade.data('item')] !== 'undefined') { // making sure that this isn't one of the images whose spot in imagesLoaded has been unset, due to there being no reviews for this particular sku
              var imgCopy = this;

              img.add(shade).css({ 'width': this.width });
              imagesLoaded[shade.data('item')] = true;
              checkImages(function () {
                setUpFlexslider(parseFloat(imgCopy.width));
              });
            }
          });
          imagesLoaded[shade.data('item')] = false;
        });

        // Make shade review #4 default shade review
        thisFormatter.find('.product .shades .manual-reviews').find('.manual-review').filter(function () {
          var self = $(this);

          return self.attr('data-item') == defaultDataItem;
        }).fadeIn('slow');

        // Show shade box #4
        thisFormatter.find('.product .shades .manual-reviews').find('.wrapper').filter(function () {
          var self = $(this);

          return self.attr('data-item') == defaultDataItem;
        }).removeClass('hidden').addClass('active');

        // Set default swoosh bg color
        var defaultShadeColor = thisFormatter.find('.product .shades .manual-reviews').find('.wrapper.active .shade-box').attr('data-skushade');

        thisFormatter
          .find('.product .shades .shade-dd-menu .col1 .smoosh-wrapper')
          .css({ 'background-color': defaultShadeColor });

        // Set product title bg color
        thisFormatter
          .find('.product .shades .manual-reviews .product-title')
          .fadeIn('slow')
          .css({ 'color': defaultShadeColor });

        // Remove items for which there are no reviews
        thisFormatter
          .find('.shade-chooser .shade-box')
          .filter(function () {
            var self = $(this),
              skuBaseId = self.data('skubaseid');

            return thisFormatter.find('.manual-reviews #' + skuBaseId + '.manual-review').length === 0;
          }).each(function () {
            delete imagesLoaded[$(this).data('item')]; // removing these individual items from the list of required images (which only allows the flexslider to init if they're all loaded)
          }).parent('li').remove();

        // grab the price box from the "main" SPP controls (gotta wait for the site.spp.init function to run)
        $(document).one('site.spp.init.finished', function () { // to make sure that this only fires once, EVEN if the spp.init.finished event fires twice or more
          thisFormatter.find('.add-to-bag.button').each(function () {
            var button = $(this),
              skuBaseId = button.attr('data-skubaseid'),
              matchedSkus = $(site.spp.data.product.skus).filter(function () { // pulled from clinique_product_spp_v1.js
                return this.SKU_BASE_ID.toString() === skuBaseId;
              }),
              matchedSku;

            if (matchedSkus) {
              if (matchedSkus.length === 1) {
                matchedSku = matchedSkus[0];
              } else if (matchedSkus.length > 1) {
              // throwing an error stops execution of script - we probably only want the error in console - no use to user either way
                console.error('Too many skus were matched for this shade, for what-people-are-saying-v1, in its init process');

                return;
              } else {
              // throwing an error stops execution of script - we probably only want the error in console - no use to user either way
                console.error('No skus were matched for this shade, for what-people-are-saying-v1, in its init process');

                return;
              }
            } else {
            // throwing an error stops execution of script - we probably only want the error in console - no use to user either way
              console.error('The sku find method failed abnormally, for what-people-are-saying-v1, in its init process');

              return;
            }
          });
        });

        // Add active class to first shade on page load
        thisFormatter.find('.shade-chooser .shade-box').filter(function () {
          var self = $(this);

          return self.attr('data-item') == defaultDataItem;
        }).addClass('active').find('img').css({ 'bottom': self.get('bottom-value-active') });

        var setUpFlexslider = function (itemWidth) {
        // Initialize Flexslider
          if ($.isFunction($.fn.flexslider)) {
            thisFormatter.once('what-people-are-saying-module-v1-flexslider').each(function () {
              var thisSlider = $(this);
              var flexsliderID = thisSlider.find('.product .shades .col2 .flexslider').attr('id');
              var flexslider = $('#' + flexsliderID);
              var flexsliderDir = flexslider.data('direction');
              var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;
              var slideshow = false;

              if (flexslider.hasClass('flexslider-slideshow')) {
                slideshow = true;
              }

              var itemMargin = 10;

              flexslider.fitVids().flexslider({
                animation: 'slide',
                // before: function(slider) {},
                // after: function(slider) {},
                startAt: 0,
                itemMargin: itemMargin,
                itemWidth: itemWidth,
                minItems: 5,
                maxItems: 10,
                slideshow: slideshow,
                video: false,
                move: 1,
                controlNav: false,
                animationSpeed: 300,
                animationLoop: true,
                rtl: rtl
              }); // flexslider
            });
          }
          // Ends Flexslider

          // Loop through the available shades
          thisFormatter.find('.shade-chooser .shade-box').each(function () {
            var shade = $(this);

            // Choose shades' reviews on click
            shade.find('img').on('click', function () {
              var thisShade = $(this).parent();
              var thisBgColor = thisShade.attr('data-skushade');

              if (thisShade.is(':not(.active)')) {
                // Set shade opacity to 1
                thisShade.find('img').css({ 'opacity': '1' });

                // Set this to active. Unset siblings active
                thisShade
                  .toggleClass('active')
                  .parent()
                  .siblings()
                  .find('.shade-box')
                  .removeClass('active');

                // Reset non active shades to bottom start value on click
                thisShade
                  .parents('.shade-chooser')
                  .find('.shade-box')
                  .not('.active')
                  .find('img')
                  .animate({
                    bottom: self.get('bottom-value-start')
                  }, 300, function () {
                  // do nothing...
                  });

                // Animate active shade to bottom active value
                thisShade
                  .find('img')
                  .animate({
                    bottom: self.get('bottom-value-active')
                  }, 300, function () {
                  // do nothing...
                  });

                // Set swoosh bg color
                thisFormatter
                  .find('.product .shades .shade-dd-menu .col1 .smoosh-wrapper')
                  .css({ 'background-color': thisBgColor });

                // Set product title bg color
                thisFormatter
                  .find('.product .shades .manual-reviews .product-title')
                  .css({ 'color': thisBgColor });
                // .fadeIn('slow');

                // Add active class to this shade
                // Set add-to-bag button bg color
                // Hide other shades' reviews
                thisFormatter.find('.manual-reviews').find('.wrapper').find('.shade-box').filter(function () {
                  var self = $(this);

                  return self.attr('data-skubaseid') == thisShade.attr('data-skubaseid');
                }).parent()
                  .toggleClass('active hidden')
                  .siblings('.wrapper')
                  .addClass('hidden')
                  .removeClass('active');

                // Show matched review
                thisFormatter
                  .find('.manual-reviews')
                  .find('#' + thisShade.attr('data-skubaseid') + '.manual-review')
                  .fadeIn('slow')
                  .closest('product-title')
                  .hide()
                  .delay(400)
                  .fadeIn('slow');

                // Hide unmatched reviews
                thisFormatter
                  .find('.manual-review')
                  .not('#' + thisShade.attr('data-skubaseid'))
                  .hide();
              }
            });

            // MouseOver/Out
            shade.find('img').on('mouseover', function () {
              var thisShade = $(this).parent();

              thisShade.not('.active').find('img').animate({
                bottom: self.get('bottom-value-hover')
              }, 300, function () {
              // do nothing...
              });
            });

            shade.find('img').on('mouseout', function () {
              var thisShade = $(this).parent();

              thisShade.not('.active').find('img').animate({
                bottom: self.get('bottom-value-start')
              }, 300, function () {
              // do nothing...
              });
            });
          });

          // remove slider controls, and center slider items, if there are not enough to exceed the width of the carousel
          var $itemSet = thisFormatter.find('.shade-chooser .slides li'),
            itemSetWidth = 0,
            flexsliderViewportWidth = parseFloat(thisFormatter.find('.flex-viewport').css('width'));

          $itemSet.each(function () {
            var $this = $(this),
              thisWidth = parseFloat($this.css('width'));

            itemSetWidth += thisWidth;
          });
          if (itemSetWidth <= flexsliderViewportWidth) {
            thisFormatter.find('.shade-chooser .flex-direction-nav').remove();
            $itemSet.parent().css({
              'width': (itemSetWidth + 1) + 'px',
              'margin': '0 auto'
            });
          }

          thisFormatter.find('.shade-chooser .shade-box:first img').trigger('click');
        };
      });

      // Add to Bag
      $('.add-to-bag.button', formatter).once('what-people-are-saying-init-add-to-bag').on('click', function(e) {
        e.preventDefault();
        // get sku for 'add to cart'
        var buySkus = [];

        buySkus = $(this).attr('data-skubaseid');
        // add sku to cart
        site.addToCart({
          skuBaseId: buySkus
        });
      });
    }
  };
})(jQuery);
